module.exports = __webpack_public_path__ + "img/yellow-ball-2.50790d8a.svg";